import { environment } from '../../../environments/environment';

export enum ErrorCode {
    HARDWARE_NOT_FOUND = 'Aut-CA-001',
    CAPTURE_TIME_EXCEEDED = 'Aut-CA-004',
    ATTEMPTS_EXCEEDED = 'Aut-CA-006',
    LOCATION_ERROR = 'Aut-CA-007',
    BACKEND_ERROR = 'Aut-CA-008',
    UNREGISTERED_CAPTOR = 'Aut-CA-009',
    ATTEMPTS_PER_DAY_EXCEEDED = 'Aut-VA-001',
    NO_FINGERPRINTS_CAPTURED = 'Aut-VA-002',
    NO_HIT = 'Aut-VA-003',
    EXPDATE_MISMATCH = 'Aut-VA-005',
}

export const ERROR_DATA: Record<ErrorCode, ErrorPageData> = {
    [ErrorCode.HARDWARE_NOT_FOUND]: {
        emptyStateData: {
            title: 'Biométrico no identificado',
            imageType: 'connection-error',
            description: /* HTML */ `En este momento no podemos identificar el lector biométrico.
                Por favor, verifica tu conexión o inténtalo más tarde.<br />
                Si el problema continúa, contacta a nuestro servicio técnico al
                ${environment.technicalServicePhoneNumber}. (${ErrorCode.HARDWARE_NOT_FOUND})`,
        },
    },
    [ErrorCode.CAPTURE_TIME_EXCEEDED]: {
        modalData: {
            title: 'Superaste el tiempo límite de lectura de huellas',
            subtitle: `Por favor, intenta nuevamente la lectura de huellas.
            Si notas un error, contacta a nuestro servicio técnico al ${environment.technicalServicePhoneNumber}.
            (${ErrorCode.CAPTURE_TIME_EXCEEDED})`,
            btnText: 'Intentar de nuevo',
        },
    },
    [ErrorCode.ATTEMPTS_EXCEEDED]: {
        emptyStateData: {
            title: 'Superaste el límite de intentos permitidos',
            description: `Por favor, espera unos minutos y vuelve a intentarlo. (${ErrorCode.ATTEMPTS_EXCEEDED})`,
            imageType: 'final-error',
            redirectTo: '**'
        },
    },
    [ErrorCode.LOCATION_ERROR]: {
        emptyStateData: {
            title: 'Error al obtener la ubicación',
            description: `Asegúrate de tener activado el GPS y tener los permisos de ubicación.
            Si el problema continúa, contacta a nuestro servicio técnico al ${environment.technicalServicePhoneNumber}.
            (${ErrorCode.LOCATION_ERROR})`,
            imageType: 'location-error',
            redirectTo: 'regulation-rnec',
        },
    },
    [ErrorCode.BACKEND_ERROR]: {
        emptyStateData: {
            title: 'Error de validación de huellas',
            description: ` Por favor, verifica tu conexión a internet e intenta nuevamente.
            Si el problema continúa, contacta a nuestro servicio técnico al ${environment.technicalServicePhoneNumber}.
            (${ErrorCode.BACKEND_ERROR})`,
            imageType: 'connection-error',
            redirectTo: 'rnec',
        },
    },
    [ErrorCode.UNREGISTERED_CAPTOR]: {
        emptyStateData: {
            title: 'Captor no registrado',
            description: `El captor de huellas no está registrado en la base de datos. Por favor, inténtalo de nuevo.
            Si el problema persiste, contacta a nuestro servicio técnico al ${environment.technicalServicePhoneNumber}.
            (${ErrorCode.UNREGISTERED_CAPTOR})`,
            imageType: 'security-cases',
            redirectTo: '**',
        },
    },
    [ErrorCode.ATTEMPTS_PER_DAY_EXCEEDED]: {
        emptyStateData: {
            title: 'El usuario superó el número de intentos diarios',
            imageType: 'attempts-error',
            description: /* HTML */ `Solicítale al usuario que lo intente en 24 horas o que visite
                el canal web para continuar. <br />
                Si el problema persiste, contacta a nuestro servicio técnico al
                ${environment.technicalServicePhoneNumber}. (${ErrorCode.ATTEMPTS_PER_DAY_EXCEEDED})`,
        },
    },
    [ErrorCode.NO_FINGERPRINTS_CAPTURED]: {
        emptyStateData: {
            title: 'Debes forzar la detención de agente',
            imageType: 'final-error',
            description: /* HTML */ `Por favor, sigue las instrucciones para forzar la detención:
                <br />
                <br />
                <ul>
                    <li>Ve al menú de aplicaciones y busca el agente.</li>
                    <li>Mantén presionado el agente durante unos segundos.</li>
                    <li>Selecciona "Info. de la aplicación" y luego "Forzar detención".</li>
                    <li>
                        Regresa al flujo y actualiza la página.
                        (${ErrorCode.NO_FINGERPRINTS_CAPTURED})
                    </li>
                </ul>`,
        },
    },
    [ErrorCode.NO_HIT]: {
        modalData: {
            title: 'Huella no identificada',
            subtitle: `En este momento no es posible validar la huella. Por favor, inténtalo de nuevo.
            (${ErrorCode.NO_HIT})`,
            btnText: 'Intentar de nuevo',
        },
    },
    [ErrorCode.EXPDATE_MISMATCH]: {
        emptyStateData: {
            title: 'La fecha de expedición es incorrecta',
            imageType: 'document-error',
            description: `Verifica la información e intenta nuevamente. Si el problema continúa, contacta a nuestro servicio
            técnico al ${environment.technicalServicePhoneNumber}. (${ErrorCode.EXPDATE_MISMATCH})`,
        },
    },
};

export interface ErrorPageData {
    modalData?: ModalData;
    emptyStateData?: EmptyStateData;
}

export interface ModalData {
    title: string;
    subtitle: string;
    btnText: string;
}

export interface EmptyStateData {
    title: string;
    description: string;
    imageType: string;
    redirectTo?: string;
}



// WEBPACK FOOTER //
// ./src/app/models/error-codes-v2.ts